import axios from 'axios';
import {
  SilalRequestInterceptors,
  SilalResponseInterceptors,
} from './interceptor';
// import { getCacheInterceptor } from './cache_interceptor';
import { Config, ConfigSelector } from './configutation';
import { USER_TYPE } from '../../config/constants';

function _getAxiosInstance(config: Config, appType: string) {
  const axiosInstance = axios.create();
  const interceptorSilalRequest = new SilalRequestInterceptors();
  const interceptorSilalResponse = new SilalResponseInterceptors();
  // Add custom interceptors
  axiosInstance.interceptors.request.use(
    interceptorSilalRequest.onResponse,
    interceptorSilalRequest.onError,
  );

  axiosInstance.interceptors.response.use(
    interceptorSilalResponse.onResponse,
    interceptorSilalResponse.onError,
  );

  // Add cache interceptor
  // if (appType === 'solr') {
  //   axiosInstance.defaults.adapter = getCacheInterceptor(config, {
  //     useBodyAsCacheKey: true,
  //   });
  // } else {
  //   axiosInstance.defaults.adapter = getCacheInterceptor(config);
  // }

  // TODO add smart-retry interceptor

  // TODO add pretty logger interceptor

  // Add logging interceptor
  if (config.logging) {
    axiosInstance.interceptors.request.use((request) => {
      if (config.AxiosRequestLogging) {
        console.group(
          '\x1b[43m%s\x1b[0m',
          'AxiosRequest sent to:',
          request.method?.toUpperCase() ?? '',
          request?.baseURL ?? '' + request?.url ?? '',
        );
        if (request.data) {
          console.log(
            'Request Payload is:\n',
            JSON.stringify(request.data, null, 2),
          );
        } else {
          console.log('Request sent with no payload');
        }
        console.groupEnd();
      }
      return request;
    });
    axiosInstance.interceptors.response.use((response) => {
      if (config.AxiosResponseLogging) {
        console.group(
          '\x1b[44m%s\x1b[0m',
          'AxiosResponse from:',
          response.config.method?.toUpperCase() ?? '',
          response.request.responseURL,
          response.status,
        );
        console.dir(response.data, {
          depth: 2,
          colors: true,
          showHidden: true,
        });
        console.groupEnd();
      }
      return response;
    });
  }

  // Set base URL
  switch (appType) {
    case USER_TYPE.Management:
      axiosInstance.defaults.baseURL = config.managementApiHost;
      break;
    case USER_TYPE.Seller:
      axiosInstance.defaults.baseURL = config.sellerApiHost;
      break;
    case USER_TYPE.Buyer:
      axiosInstance.defaults.baseURL = config.buyerApiHost;
      break;
    case USER_TYPE.Shared:
      axiosInstance.defaults.baseURL = config.sharedApiHost;
      break;
    case USER_TYPE.Data:
      axiosInstance.defaults.baseURL = config.dataApiHost;
      break;
    case USER_TYPE.Solr:
      axiosInstance.defaults.baseURL = config.solrApiHost;
      break;
  }

  // Set headers
  axiosInstance.defaults.headers.common['Accept'] = 'application/json';

  // Set content type
  axiosInstance.defaults.headers.post['Content-Type'] = 'application/json';

  // Set timeouts
  if (appType === USER_TYPE.Data) {
    axiosInstance.defaults.timeout = 60 * 1000;
  } else {
    axiosInstance.defaults.timeout = config.defaultTimeOut * 1000;
  }

  return axiosInstance;
}

export const solrAxiosInstance = _getAxiosInstance(
  ConfigSelector.getConfig('/tmp'),
  USER_TYPE.Solr,
);

export const sharedAxiosInstance = _getAxiosInstance(
  ConfigSelector.getConfig('/tmp'),
  USER_TYPE.Shared,
);

export const dataAxiosInstance = _getAxiosInstance(
  ConfigSelector.getConfig('/tmp'),
  USER_TYPE.Data,
);

export const sellerAxiosInstance = _getAxiosInstance(
  ConfigSelector.getConfig('/tmp'),
  USER_TYPE.Seller,
);

export const buyerAxiosInstance = _getAxiosInstance(
  ConfigSelector.getConfig('/tmp'),
  USER_TYPE.Buyer,
);

export const managementAxiosInstance = _getAxiosInstance(
  ConfigSelector.getConfig('/tmp'),
  USER_TYPE.Management,
);
